import { forwardRef, Ref } from "react";

import { ToggleButton } from "@newsela/angelou";

import {
  toggleButtonCss,
  toggleLabelCss,
} from "./ContentSettingsToggle.styles";

interface ContentSettingsToggleProps {
  checked: boolean;
  onChange: () => void;
}

export const ContentSettingsToggle = forwardRef<
  HTMLButtonElement,
  ContentSettingsToggleProps
>(
  (
    { checked, onChange }: ContentSettingsToggleProps,
    ref: Ref<HTMLButtonElement>,
  ) => {
    return (
      <ToggleButton
        __cssFor={{
          label: toggleLabelCss,
          Button: {
            root: toggleButtonCss,
          },
        }}
        label="Manage flagged content"
        pressed={checked}
        onClick={onChange}
        buttonRef={
          ref as
            | ((instance: HTMLButtonElement | null) => void)
            | React.RefObject<HTMLButtonElement>
        }
        dataProps={{ "data-qa-selector": "toggle-content-settings" }}
      />
    );
  },
);
